module.exports = class yItemsLoop {

    constructor () {
        this.placeOrderAndUpdateAtOnYItem = this.placeOrderAndUpdateAtOnYItem.bind(this)
    }

    placeOrderAndUpdateAtOnYItem (yItem) {
        yItem.item_order = yItem.get('order')

        const updatedTime = '' + yItem.get('updated_at')
        if (yItem._item_updatedTime !== updatedTime) {
            yItem._item_updatedTime = updatedTime
            yItem.item_updateTimestamp = new Date(updatedTime).getTime()
        }
        return yItem
    }

    getItems (yItems) {
        if (yItems) {
            return yItems.toArray()
                .map(this.placeOrderAndUpdateAtOnYItem)
                .filter(yItem => typeof yItem.item_order === 'number')
                .sort((a, b) => {
                    // Sort order asc
                    if (a.item_order < b.item_order) return -1
                    if (a.item_order > b.item_order) return 1
                    // Sort updated_at desc
                    if (a.item_updateTimestamp < b.item_updateTimestamp) return 1
                    if (a.item_updateTimestamp > b.item_updateTimestamp) return -1
                    // Dont update the position
                    return 0
                })
        }

        return []
    }

    getItemsFromYBlock (yBlock) {
        if (yBlock) {
            return this.getItems(yBlock.get('items'))
        }
        return []
    }

    yItemsToIds (yItems) {
        let ids = []
        for (let i = 0; i < yItems.length; i++) {
            let id = yItems[i].get('id')
            if (id) {
                ids.push(id)
            }
        }

        return ids
    }
}
